import { Flex } from '@chakra-ui/react';
import { sanitizeHtml } from '../../../../components/content-asset/sanitize-html';
import { Accordion, AccordionItem } from '../../../../ui-components/accordion';
import { useContentAsset } from '../../../../utils/api';
import { ContentAssetID } from '../../../../utils/api/ContentAssetID';
import { prepareAccordionContentAsset } from '../../utils/cart-utils';

export interface OnlineClassPolicyProps {
    id: string;
}
export const OnlineClassPolicy = ({ id }: OnlineClassPolicyProps) => {
    const cancellationPolicyContent = useContentAsset(ContentAssetID.CART_ONLINE_CULINARY_POLICY);
    const { title, remainingContent } = prepareAccordionContentAsset(cancellationPolicyContent);
    const contentAssetHeader = (
        <Flex
            dangerouslySetInnerHTML={{
                __html: sanitizeHtml(title),
            }}
        />
    );

    return (
        <Accordion>
            <AccordionItem id={id} title={contentAssetHeader} borderColor="slt-pepper.400">
                <Flex
                    dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(remainingContent),
                    }}
                />
            </AccordionItem>
        </Accordion>
    );
};
